import React from 'react';

import * as DiscoveryActions from './actions';
import * as D from './deps';
import DiscoveryReducer from './reducer';
import Watchers from './sagas/watchers';
import { ingestBrowseDirectoryData } from './sagas/workers';
import * as DiscoverySelectors from './selectors';
import * as DiscoveryUtils from './utils';

export default D.createDomainModule({
  name: 'discovery',
  components: {
    BrowseContainer: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_browse_v2" */ './components/Browse/BrowseContainer',
            )
          }
        />
      );
    },
    Browse: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_browse_v2" */ './components/Browse/Browse')
          }
        />
      );
    },
    BrowseAll: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_browse_v2" */ './components/Browse/BrowseAll')
          }
        />
      );
    },
    BrowseModule: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_browse_v2" */ './components/Browse/BrowseModule')
          }
        />
      );
    },
  },
  actions: DiscoveryActions,
  reducer: DiscoveryReducer,
  selectors: DiscoverySelectors,
  utils: DiscoveryUtils,
  onLoad(store) {
    return this.runSaga(store, ingestBrowseDirectoryData).toPromise();
  },
  onStart() {
    this.registeredHandlers = D.registerHandlers(Watchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
